import { useEffect } from 'react';
import { useAppDispatch } from '@/app/hooks';
import { setNavScrolled } from '@/features/ui/uiSlice';

/** Listens to window scroll and updates navScrolled state in Redux.
 *  Uses rAF throttling so the Redux dispatch (and resulting re-render)
 *  fires at most once per animation frame, not on every scroll event. */
export function useScrollBehavior() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    let rafId: number | null = null;

    const handleScroll = () => {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(() => {
        dispatch(setNavScrolled(window.scrollY > 20));
        rafId = null;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (rafId !== null) cancelAnimationFrame(rafId);
    };
  }, [dispatch]);
}
